import React from 'react';
import PropTypes from 'prop-types';
import {
	Container,
	ContentContainer,
	TopLine,
	ShadowBox,
	ContentLineSection,
	LoadingLine,
	LoadingLineWrapper,
} from './card.styled';
import {TopBarAndChip} from './top_bar_and_chip';

export const CardLoader = ({height}) => {
	return (
		<Container height={height}>
			<ShadowBox className="shadow-box" />
			<TopBarAndChip />
			<ContentContainer>
				<TopLine></TopLine>
				<ContentLineSection>
					<LoadingLineWrapper>
						<LoadingLine></LoadingLine>
						<LoadingLine small={true}></LoadingLine>
					</LoadingLineWrapper>
				</ContentLineSection>
			</ContentContainer>
		</Container>
	);
};

CardLoader.propTypes = {
	height: PropTypes.number,
};
